import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import styles from './styles.css';

export const OfferTitle = ({ title }: { title: string }) => (
    <Text className={cn(styles.offerTitle, styles.external)} tag="div" view="primary-small">
        {title}
    </Text>
);
